/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`days-off?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { day_off_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`days-off/${day_off_id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  countDaysOff({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`days-off/count-dayoffs?${new URLSearchParams(query)}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createDayOff({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`days-off`, payload)
        .then((response) => {
          commit("ADD_DAYOFF", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDayOff({ commit }, { day_off_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`days-off/${day_off_id}?`, payload)
        .then((response) => {
          commit("UPDATE_DAYOFF", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  approve({ commit }, { day_off_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`days-off/${day_off_id}/approve`, payload)
        .then((response) => {
          commit("UPDATE_DAYOFF", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  reject({ commit }, { day_off_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`days-off/${day_off_id}/reject`, payload)
        .then((response) => {
          commit("UPDATE_DAYOFF", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  delete({ commit }, { day_off_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`days-off/${day_off_id}`, payload)
        .then((response) => {
          commit("REMOVE_RECORD", day_off_id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};
